import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelectedOrganisationId, useToken } from './session';

export function RequireAuth({ children }: { children: ReactNode }) {
  const token = useToken();
  const location = useLocation();
  if (!token) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return <>{children}</>;
}

export function RequireOrganisation({ children }: { children: ReactNode }) {
  const organisationId = useSelectedOrganisationId();
  if (!organisationId) return <Navigate to="/setup" replace />;
  return <>{children}</>;
}
